// extracted by mini-css-extract-plugin
export default {"container":"Description-module__container__BUVoeij","text-wrapper":"Description-module__text-wrapper__h9X8WWA","text":"Description-module__text__zy5kOz6"};